import _toConsumableArray from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable no-unused-vars */
import { useLazyQuery } from '@apollo/client';
import { GET_MY_GROUPS_QUERY, GET_POSTS, SPACE_NOTIFICATIONS } from '@app/apollo/queries';
import { useUser } from '@app/helpers/hooks';
import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import io from 'socket.io-client';
import { SPACE_MESSAGES_STATUS_ENUM } from '@app/constants';
import { jsx as _jsx } from "react/jsx-runtime";
var SpacesContext = /*#__PURE__*/createContext();
var socketUrl = process.env.NEXT_PUBLIC_SOCKET_URL;

// Helper function to calculate total unread messages
var calculateTotalUnread = function calculateTotalUnread(notifications) {
  if (!notifications) return 0;
  return notifications.reduce(function (sum, space) {
    var spaceUnread = space.groups.reduce(function (groupSum, group) {
      return groupSum + group.unread_messages;
    }, 0);
    return sum + spaceUnread;
  }, 0);
};

// Helper function to update notifications and unread count
var updateNotificationsAndCount = function updateNotificationsAndCount(data, setNotifications, setGlobalUnreadCount) {
  if (data !== null && data !== void 0 && data.spaceNotifications) {
    setNotifications(data.spaceNotifications);
    var totalUnread = calculateTotalUnread(data.spaceNotifications);
    setGlobalUnreadCount(totalUnread);
  }
};

// Helper function to refresh notifications
var refreshNotifications = function refreshNotifications(getSpaceNotifications, setNotifications, setGlobalUnreadCount) {
  getSpaceNotifications({
    onCompleted: function onCompleted(data) {
      return updateNotificationsAndCount(data, setNotifications, setGlobalUnreadCount);
    }
  });
};

// eslint-disable-next-line react/prop-types
var SpacesProvider = function SpacesProvider(_ref) {
  var _spaceDetail$opportun, _spaceDetail$opportun2, _spaceDetail$opportun3, _spaceDetail$organisa, _spaceDetail$organisa2, _spaceDetail$opportun4, _spaceDetail$opportun5, _spaceDetail$organisa3, _spaceDetail$opportun6, _spaceDetail$opportun7, _spaceDetail$organisa4, _selectedGroup$users2;
  var children = _ref.children;
  var _useUser = useUser(),
    user = _useUser.user;
  var _useState = useState([]),
    messages = _useState[0],
    setMessages = _useState[1];
  var _useState2 = useState(null),
    selectedGroup = _useState2[0],
    setSelectedGroup = _useState2[1];
  var _useState3 = useState(null),
    spaceDetail = _useState3[0],
    setSpaceDetail = _useState3[1];
  var _useState4 = useState([]),
    spaceGroups = _useState4[0],
    setSpaceGroups = _useState4[1];
  var _useState5 = useState([]),
    notifications = _useState5[0],
    setNotifications = _useState5[1];
  var _useState6 = useState(null),
    socket = _useState6[0],
    setSocket = _useState6[1];
  var _useState7 = useState([]),
    subscribedGroups = _useState7[0],
    setSubscribedGroups = _useState7[1];
  var _useState8 = useState([]),
    currentChatComments = _useState8[0],
    setCurrentChatComments = _useState8[1];
  var _useState9 = useState(0),
    globalUnreadCount = _useState9[0],
    setGlobalUnreadCount = _useState9[1];
  var spaceOrganisationEmail = (spaceDetail === null || spaceDetail === void 0 ? void 0 : (_spaceDetail$opportun = spaceDetail.opportunity) === null || _spaceDetail$opportun === void 0 ? void 0 : (_spaceDetail$opportun2 = _spaceDetail$opportun.organisation) === null || _spaceDetail$opportun2 === void 0 ? void 0 : (_spaceDetail$opportun3 = _spaceDetail$opportun2.user) === null || _spaceDetail$opportun3 === void 0 ? void 0 : _spaceDetail$opportun3.email) || (spaceDetail === null || spaceDetail === void 0 ? void 0 : (_spaceDetail$organisa = spaceDetail.organisation) === null || _spaceDetail$organisa === void 0 ? void 0 : (_spaceDetail$organisa2 = _spaceDetail$organisa.user) === null || _spaceDetail$organisa2 === void 0 ? void 0 : _spaceDetail$organisa2.email);
  var spaceOrganisationName = (spaceDetail === null || spaceDetail === void 0 ? void 0 : (_spaceDetail$opportun4 = spaceDetail.opportunity) === null || _spaceDetail$opportun4 === void 0 ? void 0 : (_spaceDetail$opportun5 = _spaceDetail$opportun4.organisation) === null || _spaceDetail$opportun5 === void 0 ? void 0 : _spaceDetail$opportun5.name) || (spaceDetail === null || spaceDetail === void 0 ? void 0 : (_spaceDetail$organisa3 = spaceDetail.organisation) === null || _spaceDetail$organisa3 === void 0 ? void 0 : _spaceDetail$organisa3.name);
  var spaceOrganisationLogo = (spaceDetail === null || spaceDetail === void 0 ? void 0 : (_spaceDetail$opportun6 = spaceDetail.opportunity) === null || _spaceDetail$opportun6 === void 0 ? void 0 : (_spaceDetail$opportun7 = _spaceDetail$opportun6.organisation) === null || _spaceDetail$opportun7 === void 0 ? void 0 : _spaceDetail$opportun7.logo) || (spaceDetail === null || spaceDetail === void 0 ? void 0 : (_spaceDetail$organisa4 = spaceDetail.organisation) === null || _spaceDetail$organisa4 === void 0 ? void 0 : _spaceDetail$organisa4.logo);

  // refs
  var selectedGroupRef = useRef(selectedGroup);
  var authUserRef = useRef(user);
  var _useLazyQuery = useLazyQuery(SPACE_NOTIFICATIONS, {
      fetchPolicy: 'network-only'
    }),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 1),
    getSpaceNotifications = _useLazyQuery2[0];
  useEffect(function () {
    selectedGroupRef.current = selectedGroup;
  }, [selectedGroup]);
  useEffect(function () {
    authUserRef.current = user;
  }, [user]);
  useEffect(function () {
    if (messages && spaceOrganisationEmail) {
      var userExists = messages === null || messages === void 0 ? void 0 : messages.some(function (message) {
        return message.user.email === spaceOrganisationEmail;
      });
      if (userExists) {
        setMessages(function (prevMessages) {
          return prevMessages.map(function (message) {
            return _objectSpread(_objectSpread({}, message), {}, {
              user: _objectSpread(_objectSpread({}, message.user), {}, {
                name: message.user.email === spaceOrganisationEmail ? spaceOrganisationName : message.user.name,
                avatar: message.user.email === spaceOrganisationEmail ? spaceOrganisationLogo : message.user.avatar
              }),
              status: SPACE_MESSAGES_STATUS_ENUM.SENT
            });
          });
        });
        refreshNotifications(getSpaceNotifications, setNotifications, setGlobalUnreadCount);
      }
    }
  }, [(messages === null || messages === void 0 ? void 0 : messages.length) > 0, spaceOrganisationEmail]);
  useEffect(function () {
    if (currentChatComments && spaceOrganisationEmail) {
      var userExists = currentChatComments === null || currentChatComments === void 0 ? void 0 : currentChatComments.some(function (message) {
        return message.user.email === spaceOrganisationEmail;
      });
      if (userExists) {
        setCurrentChatComments(function (prevMessages) {
          return prevMessages.map(function (message) {
            return _objectSpread(_objectSpread({}, message), {}, {
              user: _objectSpread(_objectSpread({}, message.user), {}, {
                name: message.user.email === spaceOrganisationEmail ? spaceOrganisationName : message.user.name,
                avatar: message.user.email === spaceOrganisationEmail ? spaceOrganisationLogo : message.user.avatar
              })
            });
          });
        });
      }
    }
  }, [(currentChatComments === null || currentChatComments === void 0 ? void 0 : currentChatComments.length) > 0, spaceOrganisationEmail]);
  useEffect(function () {
    if (selectedGroup !== null && selectedGroup !== void 0 && selectedGroup.users && spaceOrganisationEmail) {
      var _selectedGroup$users;
      var userExists = selectedGroup === null || selectedGroup === void 0 ? void 0 : (_selectedGroup$users = selectedGroup.users) === null || _selectedGroup$users === void 0 ? void 0 : _selectedGroup$users.some(function (person) {
        return person.email === spaceOrganisationEmail;
      });
      if (userExists) {
        setSelectedGroup(function (prev) {
          return _objectSpread(_objectSpread({}, prev), {}, {
            users: prev.users.map(function (person) {
              return _objectSpread(_objectSpread({}, person), {}, {
                name: person.email === spaceOrganisationEmail ? spaceOrganisationName : person.name,
                avatar: person.email === spaceOrganisationEmail ? spaceOrganisationLogo : person.avatar
              });
            })
          });
        });
      }
    }
  }, [(selectedGroup === null || selectedGroup === void 0 ? void 0 : (_selectedGroup$users2 = selectedGroup.users) === null || _selectedGroup$users2 === void 0 ? void 0 : _selectedGroup$users2.length) > 0, spaceOrganisationEmail]);
  useEffect(function () {
    if (user) {
      refreshNotifications(getSpaceNotifications, setNotifications, setGlobalUnreadCount);
    }
  }, [user]);
  var listenForMessages = function listenForMessages() {
    var group = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    socket.on("newMessage", function (newMessages) {
      var _newMessages$;
      setMessages(newMessages);
      if (!selectedGroupRef.current || ((_newMessages$ = newMessages[0]) === null || _newMessages$ === void 0 ? void 0 : _newMessages$.space_group_id) !== selectedGroupRef.current.id) {
        refreshNotifications(getSpaceNotifications, setNotifications, setGlobalUnreadCount);
      }
    });
  };
  var listenForComments = function listenForComments() {
    var group = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    socket.on("newComment", function (comment) {
      var _selectedGroupRef$cur;
      setCurrentChatComments(function (prevComments) {
        var commentExists = prevComments === null || prevComments === void 0 ? void 0 : prevComments.some(function (c) {
          return c.uid === comment.uid;
        });
        if (commentExists) {
          return prevComments === null || prevComments === void 0 ? void 0 : prevComments.map(function (msg) {
            if (msg.uid === comment.uid) {
              return _objectSpread(_objectSpread({}, msg), {}, {
                emoji_reactions: comment.emoji_reactions
              });
            }
            return msg;
          });
        }
        return [].concat(_toConsumableArray(prevComments), [comment]);
      });
      if (((_selectedGroupRef$cur = selectedGroupRef.current) === null || _selectedGroupRef$cur === void 0 ? void 0 : _selectedGroupRef$cur.id) === comment.space_group_id) {
        var _selectedGroupRef$cur2;
        setMessages(function (prevMessages) {
          return prevMessages.map(function (msg) {
            if (msg.uid === comment.post_id) {
              return _objectSpread(_objectSpread({}, msg), {}, {
                comments_count: (msg.comments_count || 0) + 1
              });
            }
            return msg;
          });
        });
        if (comment.post_id !== ((_selectedGroupRef$cur2 = selectedGroupRef.current) === null || _selectedGroupRef$cur2 === void 0 ? void 0 : _selectedGroupRef$cur2.id)) {
          refreshNotifications(getSpaceNotifications, setNotifications, setGlobalUnreadCount);
        }
      } else {
        refreshNotifications(getSpaceNotifications, setNotifications, setGlobalUnreadCount);
      }
    });
  };
  var joinGroup = function joinGroup(group) {
    socket.emit('joinGroup', group.id);
  };
  var leaveGroup = function leaveGroup(group) {
    socket.emit('leaveGroup', group.id);
  };
  var _useLazyQuery3 = useLazyQuery(GET_MY_GROUPS_QUERY),
    _useLazyQuery4 = _slicedToArray(_useLazyQuery3, 2),
    getMyGroupsQuery = _useLazyQuery4[0],
    _useLazyQuery4$ = _useLazyQuery4[1],
    _useLazyQuery4$$data = _useLazyQuery4$.data;
  _useLazyQuery4$$data = _useLazyQuery4$$data === void 0 ? [] : _useLazyQuery4$$data;
  var myGroups = _useLazyQuery4$$data.myGroups,
    loadingMyGroups = _useLazyQuery4$.loading;
  useEffect(function () {
    if (user) {
      getMyGroupsQuery();
      authUserRef.current = user;
    }
  }, [user]);
  useEffect(function () {
    if (myGroups && socket && user) {
      myGroups.forEach(function (group) {
        joinGroup(group);
      });
      setSubscribedGroups(myGroups.myGroups);
    }
    return function () {
      if (subscribedGroups && socket) {
        subscribedGroups.forEach(function (group) {
          leaveGroup(group);
        });
      }
    };
  }, [myGroups, socket, user]);
  useEffect(function () {
    if (socketUrl) {
      var socketConn = io(socketUrl, {
        path: '/socket.io',
        transports: ['websocket'],
        reconnection: true,
        reconnectionAttempts: 5,
        reconnectionDelay: 1000
      });
      socketConn.on('connect', function () {
        console.log('Connected to socket server');
      });
      socketConn.on('connect_error', function (error) {
        console.error('Socket connection error:', error);
      });
      setSocket(socketConn);
    }
    return function () {
      if (socket) {
        socket.disconnect();
      }
    };
  }, []);
  var _useLazyQuery5 = useLazyQuery(GET_POSTS, {
      fetchPolicy: 'network-only'
    }),
    _useLazyQuery6 = _slicedToArray(_useLazyQuery5, 2),
    getPosts = _useLazyQuery6[0],
    loadingPosts = _useLazyQuery6[1].loading;
  useEffect(function () {
    if (selectedGroup) {
      setMessages([]);
      getPosts({
        variables: {
          groupId: selectedGroup.id
        },
        onCompleted: function onCompleted(res) {
          if (res.spaceGroupPosts.length > 0) {
            var _res$spaceGroupPosts;
            var userExists = spaceOrganisationEmail && ((_res$spaceGroupPosts = res.spaceGroupPosts) === null || _res$spaceGroupPosts === void 0 ? void 0 : _res$spaceGroupPosts.some(function (message) {
              var _message$user;
              return (message === null || message === void 0 ? void 0 : (_message$user = message.user) === null || _message$user === void 0 ? void 0 : _message$user.email) === spaceOrganisationEmail;
            }));
            if (userExists) {
              var _res$spaceGroupPosts2;
              setMessages((_res$spaceGroupPosts2 = res.spaceGroupPosts) === null || _res$spaceGroupPosts2 === void 0 ? void 0 : _res$spaceGroupPosts2.map(function (post) {
                return _objectSpread(_objectSpread({}, post), {}, {
                  user: _objectSpread(_objectSpread({}, post.user), {}, {
                    name: post.user.email === spaceOrganisationEmail ? spaceOrganisationName : post.user.name,
                    avatar: post.user.email === spaceOrganisationEmail ? spaceOrganisationLogo : post.user.avatar
                  }),
                  status: SPACE_MESSAGES_STATUS_ENUM.SENT
                });
              }));
            } else {
              setMessages(res.spaceGroupPosts);
            }
            refreshNotifications(getSpaceNotifications, setNotifications, setGlobalUnreadCount);
          } else {
            setMessages([]);
          }
        }
      });
    }
  }, [selectedGroup]);
  var listenForNotifications = function listenForNotifications() {
    socket.on("notificationUpdate", function (updatedNotifications) {
      updateNotificationsAndCount({
        spaceNotifications: updatedNotifications
      }, setNotifications, setGlobalUnreadCount);
    });
  };
  useEffect(function () {
    if (socket) {
      listenForMessages();
      listenForComments();
      listenForNotifications();
    }
  }, [socket]);
  return /*#__PURE__*/_jsx(SpacesContext.Provider, {
    value: {
      messages: messages,
      setMessages: setMessages,
      selectedGroup: selectedGroup,
      setSelectedGroup: setSelectedGroup,
      spaceDetail: spaceDetail,
      setSpaceDetail: setSpaceDetail,
      spaceGroups: spaceGroups,
      setSpaceGroups: setSpaceGroups,
      currentChatComments: currentChatComments,
      setCurrentChatComments: setCurrentChatComments,
      globalUnreadCount: globalUnreadCount,
      setGlobalUnreadCount: setGlobalUnreadCount,
      socket: socket,
      loadingPosts: loadingPosts,
      notifications: notifications
    },
    children: children
  });
};
export var useSpaces = function useSpaces() {
  return useContext(SpacesContext);
};
export default SpacesProvider;